<template>
  <v-select :items="items" label="Icone" v-model="group.icone">
    <template template v-slot:selection="{ item }">
      <v-icon>{{ item }}</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-icon>{{ item }}</v-icon>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "IconeSelect",
  props: ["group"],
  data: () => ({
    items: [
      "fas fa-address-book",
      "fas fa-address-card",
      "fas fa-ambulance",
      "fas fa-american-sign-language-interpreting",
      "fas fa-anchor",
      "fas fa-angle-double-down",
      "fas fa-angle-double-left",
      "fas fa-angle-double-right",
      "fas fa-angle-double-up",
      "fas fa-angle-down",
      "fas fa-angle-left",
      "fas fa-angle-right",
      "fas fa-angle-up",
      "fas fa-archive",
      "fas fa-assistive-listening-systems",
      "fas fa-asterisk",
      "fas fa-at",
      "fas fa-audio-description",
      "fas fa-barcode",
      "fas fa-bars",
      "fas fa-bath",
      "fas fa-bell",
      "fas fa-bell-slash",
      "fas fa-bicycle",
      "fas fa-binoculars",
      "fas fa-birthday-cake",
      "fas fa-blind",
      "fas fa-bold",
      "fas fa-bolt",
      "fas fa-bomb",
      "fas fa-book",
      "fas fa-bookmark",
      "fas fa-braille",
      "fas fa-briefcase",
      "fas fa-bug",
      "fas fa-building",
      "fas fa-bullhorn",
      "fas fa-bullseye",
      "fas fa-bus",
      "fas fa-calculator",
      "fas fa-calendar",
      "fas fa-camera",
      "fas fa-camera-retro",
      "fas fa-car",
      "fas fa-caret-down",
      "fas fa-caret-left",
      "fas fa-caret-right",
      "fas fa-caret-up",
      "fas fa-cart-arrow-down",
      "fas fa-cart-plus",
      "fas fa-certificate",
      "fas fa-check",
      "fas fa-check-circle",
      "fas fa-check-square",
      "fas fa-chevron-circle-down",
      "fas fa-chevron-circle-left",
      "fas fa-chevron-circle-right",
      "fas fa-chevron-circle-up",
      "fas fa-chevron-down",
      "fas fa-chevron-left",
      "fas fa-chevron-right",
      "fas fa-chevron-up",
      "fas fa-code",
      "fas fa-coffee",
      "fas fa-cog",
      "fas fa-cogs",
      "fas fa-columns",
      "fas fa-comment",
      "fas fa-compass",
      "fas fa-compress",
      "fas fa-copy",
      "fas fa-copyright",
      "fas fa-credit-card",
      "fas fa-crop",
      "fas fa-crosshairs",
      "fas fa-cube",
      "fas fa-cubes",
      "fas fa-cut",
      "fas fa-database",
      "fas fa-desktop",
      "fas fa-download",
      "fas fa-ellipsis-h",
      "fas fa-ellipsis-v",
      "fas fa-envelope",
      "fas fa-exclamation",
      "fas fa-exclamation-circle",
      "fas fa-exclamation-triangle",
      "fas fa-eye",
      "fas fa-eye-slash",
      "fas fa-female",
      "fas fa-fighter-jet",
      "fas fa-file",
      "fas fa-film",
      "fas fa-filter",
      "fas fa-fire",
      "fas fa-fire-extinguisher",
      "fas fa-h-square",
      "fas fa-hashtag",
      "fas fa-headphones",
      "fas fa-heart",
      "fas fa-heartbeat",
      "fas fa-history",
      "fas fa-home",
      "fas fa-hotel",
      "fas fa-inbox",
      "fas fa-indent",
      "fas fa-industry",
      "fas fa-info",
      "fas fa-info-circle",
      "fas fa-key",
      "fas fa-laptop",
      "fas fa-leaf",
      "fas fa-lock",
      "fas fa-low-vision",
      "fas fa-magic",
      "fas fa-magnet",
      "fas fa-mobile",
      "fas fa-motorcycle",
      "fas fa-mouse-pointer",
      "fas fa-music",
      "fas fa-paperclip",
      "fas fa-paragraph",
      "fas fa-paste",
      "fas fa-pause",
      "fas fa-pause-circle",
      "fas fa-paw",
      "fas fa-percent",
      "fas fa-phone",
      "fas fa-power-off",
      "fas fa-print",
      "fas fa-save",
      "fas fa-search",
      "fas fa-shower",
      "fas fa-stop",
      "fas fa-stop-circle",
      "fas fa-street-view",
      "fas fa-train",
      "fas fa-truck",
      "fas fa-tv",
      "fas fa-umbrella",
      "fas fa-underline",
      "fas fa-undo",
      "fas fa-universal-access",
      "fas fa-university",
      "fas fa-unlink",
      "fas fa-unlock",
      "fas fa-upload",
      "fas fa-user",
      "fas fa-user-circle",
      "fas fa-user-md",
      "fas fa-user-plus",
      "fas fa-user-secret",
      "fas fa-user-times",
      "fas fa-users",
    ],
  }),
};
</script>
